module.exports = __webpack_public_path__ + "img/17.968d8044.jpg";